import config from './config';
import { IConfig } from './IConfig';
import {
  featureToggle,
  REGISTRATION_DIAL_INS,
  EVERCALL_BULK_EDIT,
  EVERCALL_SAVE_AND_NOTIFY_INLINE_EDIT,
} from './featureToggle';

export type { IConfig };
export {
  featureToggle,
  REGISTRATION_DIAL_INS,
  EVERCALL_BULK_EDIT,
  EVERCALL_SAVE_AND_NOTIFY_INLINE_EDIT,
};
export default config;
